import type { DefensePosition } from "../../shared/domain/defense";
import type { GameAction } from "../shared/types/contracts";

const part = (value: string | number | null): string =>
  value === null ? "none" : String(value);

export const actionKeys = {
  claimScoring: "scoring:claim",
  teamName: "team:name",
  addPlayer: "player:add",
  attendance: (playerId: string) => `player:attendance:${playerId}`,
  preferences: (playerId: string) => `player:preferences:${playerId}`,
  jersey: (playerId: string | null) => `player:jersey:${part(playerId)}`,
  jerseyGroup: "player:jersey:",
  removePlayer: (playerId: string) => `player:remove:${playerId}`,
  suggestLineup: "lineup:suggest",
  reorderLineup: "lineup:reorder",
  opponentName: "setup:opponent",
  homeTeam: "setup:home-team",
  scheduleDetails: "setup:schedule-details",
  startGame: "game:start",
  pitcher: (playerId: string | null) => `defense:pitcher:${part(playerId)}`,
  pitcherGroup: "defense:pitcher:",
  generateDefense: "defense:generate",
  defenseAssignment: (inning: number, position: DefensePosition) =>
    `defense:${inning}:${position}`,
  defenseInning: (inning: number) => `defense:${inning}:`,
  scheduleCreate: "schedule:create",
  scheduleUpdate: (scheduleId: string) => `schedule:update:${scheduleId}`,
  scheduleSelect: (scheduleId: string) => `schedule:select:${scheduleId}`,
  scheduleSelectGroup: "schedule:select:",
  scheduleDelete: (scheduleId: string) => `schedule:delete:${scheduleId}`,
  seriesCreate: "series:create",
  seriesUpdate: (seriesId: string) => `series:update:${seriesId}`,
  seriesDelete: (seriesId: string) => `series:delete:${seriesId}`,
  seasonStart: "season:start",
  seasonClose: "season:close",
  seasonReopen: (seasonId: string) => `season:reopen:${seasonId}`,
  seasonGroup: "season:",
  inviteRotate: "invite:rotate",
  inviteRevoke: "invite:revoke",
  discardGame: "game:lifecycle:discard",
  exportStats: "stats:export",
  linkAccount: "account:link",
  unclaimPlayer: "account:unclaim",
  gameAction: (gameId: string, type: GameAction["type"]) =>
    `game:${gameId}:action:${type}`,
  gameGroup: (gameId: string) => `game:${gameId}:`,
  runnerAdvance: (gameId: string, baseIndex: number) =>
    `game:${gameId}:runner:advance:${baseIndex}`,
  runnerRemove: (gameId: string, baseIndex: number) =>
    `game:${gameId}:runner:remove:${baseIndex}`,
  rbi: (gameId: string) => `game:${gameId}:rbi`,
  opponentRun: (gameId: string) => `game:${gameId}:opponent-run`,
  endHalf: (gameId: string) => `game:${gameId}:end-half`,
  openInning: (gameId: string) => `game:${gameId}:open-inning`,
  keepPlaying: (gameId: string) => `game:${gameId}:keep-playing`,
  undo: (gameId: string) => `game:${gameId}:undo`,
  archive: (gameId: string) => `game:${gameId}:lifecycle:archive`,
  finalize: (gameId: string) => `game:${gameId}:lifecycle:finalize`,
  forfeitRecord: (gameId: string) => `game:${gameId}:lifecycle:forfeit:record`,
  forfeitSave: (gameId: string) => `game:${gameId}:lifecycle:forfeit:save`,
};
